<template>
  <div class="abeja-app-template">
    <!-- NOTE: SideBar -->
    <div
      class="abeja-app-template__sidebar"
      :style="{'width': `${paddingLeft}px`}"
    >
      <the-side-bar
        active-content="Scheduling"
        v-if="isShowSide"
        :collapsed="collapsed"
        @changeShowSideMenu="changeShowSideMenu"
        @hideSideMenu="hideSideMenu"
      />
    </div>
    <div
      class="abeja-app-template__body"
      :style="{'padding-left': `${paddingLeft}px`, 'width': `calc(100% - ${paddingLeft}px)`}"
    >
      <!-- NOTE: Header -->
      <div class="abeja-app-template__body__header">
        <the-header
          v-if="isShowHeader"
          :padding-left="paddingLeft"
        />
      </div>

      <!-- NOTE: Contents Body -->
      <div
        class="abeja-app-template__body__main"
        :style="{'transform': `translateX(calc(-50% + ${paddingLeft}px)`}"
      >
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import TheSideBar from '@/components/TheSideBar.vue'
import TheHeader from '@/components/TheHeader.vue'

export default {
  name: 'App',
  components: {
    TheSideBar,
    TheHeader
  },
  data: () => ({
    isShowSide: true,
    collapsed: true,
    isShowHeader: true
  }),
  computed: {
    paddingLeft () {
      if (!this.isShowSide) return 0
      return this.collapsed ? 64 : 190
    }
  },
  mounted () {
    // TODO: InterCom: User情報をVuexから取得して入れ込む
    /*
    this.$intercom.boot({
      // user_id: 1,
      // name: 'test user',
      email: 'hajime@abejainc.com',
    })
    // NOTE: 開くと邪魔なのでデフォルトはshowしないでおく
    // this.$intercom.show()
    */
  },
  methods: {
    changeShowSideMenu () {
      this.collapsed = !this.collapsed
    },
    hideSideMenu () {
      this.collapsed = true
    }
  }
}
</script>

<style lang="scss" scoped>
.abeja-app-template {
  position: relative;
  height: 100vh;
  width: 100vw;
  background-color: #fafafa;

  .abeja-app-template__sidebar {
    position: fixed;
    background-color: white;
    z-index: 100;
  }

  .abeja-app-template__body {
    position: absolute;
    width: 100%;
    top: 0px;

    .abeja-app-template__body__header {
      position: fixed;
      top: 0px;
      width: 100%;
      background-color: white;
      z-index: 10;
    }
    .abeja-app-template__body__main {
      position: absolute;
      top: 64px;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      max-width: 1260px;
      z-index: 0;
      background-color: white;
    }
  }
}
</style>
